import { useCustomMutation } from "@refinedev/core";
import { notification } from "antd";
import { SUBMIT_PURCHASE_REQUEST_MUTATION } from "../queries";

interface SubmitPurchaseRequestResponse {
  id: string;
  requestNo: string;
  status: string;
  approvals: Array<{
    order: number;
    roleSlug: string;
    stepName?: string;
    stepStatus: string;
  }>;
  totalAmount: number;
  approvalType?: string;
  steps?: Array<{
    order: number;
    roleSlug: string;
    stepName?: string;
  }>;
  externalWorkflow?: Record<string, any>;
  approvalData?: any;
  flowCaseId?: string;
  flowCaseNumber?: string;
  submittedBy?: string;
}

interface UseSubmitPurchaseRequestProps {
  onSuccess?: (data: SubmitPurchaseRequestResponse) => void;
  onError?: (error: any) => void;
}

export const useSubmitPurchaseRequest = ({
  onSuccess,
  onError
}: UseSubmitPurchaseRequestProps = {}) => {
  const { mutate: submitPurchaseRequest, isLoading } = useCustomMutation<SubmitPurchaseRequestResponse>();

  const submit = async (input: { requestId?: string; requestData?: any; fiscalYear: number }) => {
    try {
      const values = {
        input: {
          requestId: input.requestId,
          requestData: input.requestData,
          fiscalYear: input.fiscalYear
        }
      };

      submitPurchaseRequest({
        meta: {
          gqlMutation: SUBMIT_PURCHASE_REQUEST_MUTATION,
        },
        values: values,
        url: "",
        method: "post"
      }, {
        onSuccess: (data) => {
          const response = (data as any)?.data?.submitPurchaseRequest || data;

          notification.success({
            message: 'Purchase Request Submitted Successfully',
            description: 'The purchase request has been submitted for approval.',
          });
          onSuccess?.(response);
        },
        onError: (error) => {
          notification.error({
            message: 'Submission Failed',
            description: error.message || 'Failed to submit the purchase request.',
          });
          onError?.(error);
        }
      });
    } catch (error) {
      console.error('Error submitting purchase request:', error);
      onError?.(error);
    }
  };

  return {
    submit,
    isLoading
  };
};